import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { Observable } from 'rxjs';
import { Injectable } from "@angular/core";
import { FgiBackEndService } from "src/app/shared/fgi-back-end.service";
import { catchError } from 'rxjs/operators';
import { ModalidadeOperacionalRepasse } from 'src/app/model/modalidade-operacional-repasse';


@Injectable({
  providedIn: 'root'
})
export class ModalidadeOperacionalRepasseService extends FgiBackEndService<ModalidadeOperacionalRepasse>{

  getNewEntity() {
    return undefined;
  }

  protected getResourceURL(): string {
    return 'front/modalidade-operacional-repasse-bndes';
  }

  public buscarModalidadesPermitidas(): Observable<Array<ModalidadeOperacionalRepasse>> {
    const options = blockUi();
    return this.http.get(`${this.BASE_URL}/permitidas`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<Array<ModalidadeOperacionalRepasse>>;
  }

}

